import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import CurrencyFormatter from "currency-formatter";
import Backdrop from "@mui/material/Backdrop";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import BVAInput from "../../../../components/BVAInput/BVAInput";
import { primary } from "../../../../assets/colorPallet";
import "./button.css";
import { generateDebtPanel, updateDebtPanel, onClickDebtPanel } from "../../../../store/modules/dealOffer/actions";

function DebtPanel({
  dealType,
  debtPanel,
  dispatchGenerateDebtPanel,
  dispatchUpdateDebtPanel,
  dispatchOnClickDebtPanel
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateDebtPanel(dealType);
  }, []);

  const [isLoading, setIsLoading] = useState(true);
  setTimeout(() => {setIsLoading(false);}, 10);

  const onClick = (index, type) => {
    dispatchOnClickDebtPanel(index, type);
  };

  const handleChange = (item, value, index) => {
    dispatchUpdateDebtPanel(item, value, index);
  };

  return (
    <>
      {isLoading ? (
        <Backdrop
          sx={{ color: "fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isLoading}
        >
        </Backdrop>
      ) : (
        <div className="py-5 flex justify-center items-center flex-col" style={{ minWidth: 1820 }}>
          <div className="flex items-center text-center text-white h-20 mb-5 px-5" style={{ backgroundColor: primary }}>
            <div className="w-32" />
            <div className="w-64 font-semibold">Tranche</div>
            <div className="w-36 font-semibold">Total Balance</div>
            <div className="w-24 font-semibold">Percent of Total Value</div>
            <div className="w-24 font-semibold">Financing Fees</div>
            <div className="w-28 font-semibold">Repayment Period</div>
            <div className="w-28 font-semibold">Moratorium on Principal</div>
            <div className="w-28 font-semibold">Total Term</div>
            <div className="w-28 font-semibold">Receival Start Year</div>
            <div className="w-28 font-semibold">Fixed / Floating</div>
            <div className="w-36 font-semibold">Interest Rate</div>
            <div className="w-24 font-semibold">Floor</div>
            <div className="w-24 font-semibold">Cash Sweep</div>
            <div className="w-44 font-semibold">Type of Repay</div>
            <div className="w-24 font-semibold">PIK Interest Rate</div>
          </div>
          {debtPanel?.debtArray?.map((debt, index) => (
            <div key={index} className="flex items-center text-center mb-2">
              <button className="controlButton" onClick={() => onClick(index, "Insert")}>
                <AddCircleOutlineIcon fontSize="small" />
              </button>
              <button
                className="controlButton"
                onClick={() => onClick(index, "Remove")}
                disabled={
                  debt.name.indexOf("Equity") >= 0 ||
                  debt.name === "Line of Credit" ||
                  debt.name === "Owner Financing" ||
                  debt.name === "Assumed Debt"
                  ? true : false
                }
              >
                <RemoveCircleOutlineIcon
                  fontSize="small"
                  color={
                    debt.name.indexOf("Equity") >= 0 ||
                    debt.name === "Line of Credit" ||
                    debt.name === "Owner Financing" ||
                    debt.name === "Assumed Debt"
                    ? "disabled" : ""
                  }
                />
              </button>
              <button  className="controlButton" onClick={() => onClick(index, "Up")}>
                <ArrowCircleUpIcon fontSize="small" />
              </button>
              <button  className="controlButton" onClick={() => onClick(index, "Down")}>
                <ArrowCircleDownIcon fontSize="small" />
              </button>
              <div className="w-64">
                {
                  debt.name.indexOf("Equity") >= 0 ||
                  debt.name === "Line of Credit" ||
                  debt.name === "Owner Financing" ||
                  debt.name === "Assumed Debt"
                  ? debt.name
                  : (
                  <FormControl sx={{ minWidth: 190 }} size="small">
                    <Select value={debt.name} onChange={(e) => handleChange("name", e.target.value, index)}>
                      <MenuItem value={"Term Loan"}>Term Loan</MenuItem>
                      <MenuItem value={"Asset-Backed Loan"}>Asset-Backed Loan</MenuItem>
                      <MenuItem value={"Senior Note"}>Senior Note</MenuItem>
                      <MenuItem value={"Subordinated Note"}>Subordinated Note</MenuItem>
                      <MenuItem value={"Mezzanine Note"}>Mezzanine Note</MenuItem>
                    </Select>
                  </FormControl>)
                }
              </div>
              <div className="w-36 px-0.5">
                <BVAInput
                  size="small"
                  width="100%"
                  textAlign="start"
                  startAdornment
                  startAdornmentLabel="$ "
                  disabled={
                    debt.name === "Owner Financing" ||
                    debt.name === "Assumed Debt" ||
                    debt.name === "Sponsor Equity"
                    ? true : false
                  }
                  value={debt.value}
                  onChange={(value) => handleChange("value", value, index)}
                />
              </div>
              <div className="w-24 px-0.5">
                <BVAInput
                  size="small"
                  width="100%"
                  textAlign="end"
                  endAdornment
                  endAdornmentLabel="%"
                  disabled
                  value={debt.percent}
                />
              </div>
              <div className="w-24 px-0.5">
                {debt.name.indexOf("Equity") < 0 && (
                  <BVAInput
                    size="small"
                    width="100%"
                    textAlign="end"
                    endAdornment
                    endAdornmentLabel="%"
                    value={debt.fee}
                    onChange={(value) => handleChange("fee", value, index)}
                  />
                )}
              </div>
              <div className="w-28 px-0.5">
                {debt.name.indexOf("Equity") < 0 && (
                  <BVAInput
                    size="small"
                    width="100%"
                    textAlign="end"
                    endAdornment
                    endAdornmentLabel={debt.name === "Line of Credit" ? "" : debt.name === "Owner Financing" ? "Mos" : "Years"}
                    disabled={debt.name === "Line of Credit" || debt.name === "Owner Financing" ? true : false}
                    value={debt.name === "Line of Credit" ? "" : debt.period}
                    onChange={(value) => handleChange("period", value, index)}
                  />
                )}
              </div>
              <div className="w-28 px-0.5">
                {debt.name.indexOf("Equity") < 0 && (
                  <BVAInput
                    size="small"
                    width="100%"
                    textAlign="end"
                    endAdornment
                    endAdornmentLabel={debt.name === "Line of Credit" ? "" : debt.name === "Owner Financing" ? "Mos" : "Years"}
                    disabled={debt.name === "Line of Credit" || debt.name === "Owner Financing" ? true : false}
                    value={debt.name === "Line of Credit" ? "" : debt.moratorium}
                    onChange={(value) => handleChange("moratorium", value, index)}
                  />
                )}
              </div>
              <div className="w-28 px-0.5">
                {!debt.name.includes("Equity") && (
                  <BVAInput
                    size="small"
                    width="100%"
                    textAlign="end"
                    endAdornment
                    endAdornmentLabel={debt.name === "Line of Credit" ? "" : debt.name === "Owner Financing" ? "Mos" : "Years"}
                    disabled
                    value={debt.name === "Line of Credit" ? "" : debt.totalTerm}
                  />
                )}
              </div>
              <div className="w-28 px-0.5">
                {!debt.name.includes("Equity") && (
                  <BVAInput
                    size="small"
                    width="100%"
                    textAlign="start"
                    startAdornment
                    startAdornmentLabel={debt.name === "Line of Credit" ? "" : "Year"}
                    disabled={
                      debt.name === "Line of Credit" ||
                      debt.name === "Owner Financing" ||
                      debt.name === "Assumed Debt"
                      ? true : false
                    }
                    value={debt.name === "Line of Credit" ? "" : debt.startYear}
                    onChange={(value) => handleChange("startYear", value, index)}
                  />
                )}
              </div>
              <div className="w-28">
                {!debt.name.includes("Equity") && (
                  <FormControl sx={{ minWidth: 107 }} size="small">
                    <Select value={debt.interestType} onChange={(e) => handleChange("interestType", e.target.value, index)}>
                      <MenuItem value={"Fixed"}>Fixed</MenuItem>
                      <MenuItem value={"Floating"}>Floating</MenuItem>
                    </Select>
                  </FormControl>
                )}
              </div>
              <div className="w-36 px-0.5">
                {!debt.name.includes("Equity") && (
                  <BVAInput
                    size="small"
                    width="100%"
                    textAlign="end"
                    endAdornment
                    endAdornmentLabel={debt.interestType === "Fixed" ? "%" : "% + SOFR"}
                    disabled={debt.name === "Owner Financing" ? true : false}
                    value={debt.rate}
                    onChange={(value) => handleChange("rate", value, index)}
                  />
                )}
              </div>
              <div className="w-24 px-0.5">
                {!debt.name.includes("Equity") && (
                  <BVAInput
                    size="small"
                    width="100%"
                    textAlign="end"
                    endAdornment
                    endAdornmentLabel={debt.interestType === "Fixed" ? "" : "%"}
                    disabled={debt.interestType === "Fixed" ? true : false}
                    value={debt.interestType === "Fixed" ? "" : debt.floor}
                    onChange={(value) => handleChange("floor", value, index)}
                  />
                )}
              </div>
              <div className="w-24 px-0.5">
                {!debt.name.includes("Equity") && (
                  <BVAInput
                    size="small"
                    width="100%"
                    textAlign="end"
                    endAdornment
                    endAdornmentLabel={debt.name === "Line of Credit" ? "" : "%"}
                    disabled={debt.name === "Line of Credit" || debt.name === "Owner Financing" ? true : false}
                    value={debt.name === "Line of Credit" ? "" : debt.sweep}
                    onChange={(value) => handleChange("sweep", value, index)}
                  />
                )}
              </div>
              <div className="w-44">
                {!debt.name.includes("Equity") && (
                  debt.name === "Line of Credit" || debt.name === "Owner Financing" ? (
                    <BVAInput
                      size="small"
                      width="100%"
                      disabled
                    />
                  ) : (
                    <FormControl sx={{ minWidth: 171.5 }} size="small">
                      <Select value={debt.repayType} onChange={(e) => handleChange("repayType", e.target.value, index)}>
                        <MenuItem value={"Linear"}>Linear Schedule</MenuItem>
                        <MenuItem value={"Bullet"}>Bullet</MenuItem>
                        <MenuItem value={"PIK"}>PIK</MenuItem>
                      </Select>
                    </FormControl>
                  )
                )}
              </div>
              <div className="w-24 px-0.5">
                {!debt.name.includes("Equity") && (
                  <BVAInput
                    size="small"
                    width="100%"
                    textAlign="end"
                    endAdornment
                    endAdornmentLabel={debt.repayType === "PIK" ? "%" : ""}
                    disabled={debt.repayType === "PIK" ? false : true}
                    value={debt.repayType === "PIK" ? debt.pikRate : ""}
                    onChange={(value) => handleChange("pikRate", value, index)}
                  />
                )}
              </div>
            </div>
          ))}
          <div className="flex items-center text-center mt-3 px-5">
            <div className="w-32" />
            <div className="w-64 text-lg font-semibold">Total</div>
            <div className="w-36 font-semibold text-left pl-3">{CurrencyFormatter.format(debtPanel?.debtTotal, { code: "USD" })}</div>
            <div className="w-24 font-semibold">100 %</div>
            <div className="w-24 font-semibold text-left">{CurrencyFormatter.format(debtPanel?.feesTotal, { code: "USD" })}</div>
            <div className="w-96" />
            <div className="w-96" />
            <div className="w-96" />
            <div className="w-4" />
          </div>
        </div>
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  debtPanel: state.dealOffer.debtPanel,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateDebtPanel(dealType) {
    await dispatch(generateDebtPanel(dealType));
  },
  async dispatchUpdateDebtPanel(item, value, index) {
    await dispatch(updateDebtPanel(item, value, index));
  },
  async dispatchOnClickDebtPanel(index, type) {
    await dispatch(onClickDebtPanel(index, type));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(DebtPanel);
